import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';

import * as styles from './page-width-wrapper.scss';

export const PageWidthWrapper = ({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={clsx(styles.pageWidthWrapper, className)} {...props}>
    {children}
  </div>
);
